import { Component, OnInit, Input } from "@angular/core";

@Component({
  selector: "height-value",
  templateUrl: "./height-value.component.html",
})
export class HeightValueComponent implements OnInit {
  @Input() height: String | Number;
  @Input() textRight: boolean;
  constructor() {}

  ngOnInit() {}
}
